export default __webpack_public_path__ + "static/media/cmr_colour.4778552d.png";